export function LegalSection({title,children,t}){
  return(
    <div style={{marginBottom:20}}>
      <div style={{fontSize:13,fontWeight:800,color:t?t.tx:"#1a1a1a",fontFamily:"Inter,sans-serif",marginBottom:7}}>{title}</div>
      <div style={{fontSize:12.5,color:t?t.soft:"#555",fontFamily:"Inter,sans-serif",lineHeight:1.7}}>{children}</div>
    </div>
  );
}

export function LegalScreen({title,icon,go,backTo,children,t}){
  return(
    <div className="screen fade" style={{background:t?t.bg:"#F7F7F8"}}>
      <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t?t.bord:"rgba(0,0,0,.07)"}`,flexShrink:0,background:t?t.card:"#fff"}}>
        <div onClick={()=>go(backTo||"settings")} style={{width:32,height:32,borderRadius:"50%",background:t?t.bord:"#f1f1f1",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:14,color:t?t.tx:"#333"}}>←</div>
        <span style={{fontSize:16,fontWeight:800,color:t?t.tx:"#1a1a1a",fontFamily:"Inter,sans-serif"}}>{icon} {title}</span>
      </div>
      <div style={{padding:"18px 18px 40px",flex:1,overflowY:"auto"}}>
        {children}
      </div>
    </div>
  );
}
